import { Box } from "@mantine/core";
import { HistoryTable } from "../../../components/history-table";

const HistoryConversationsPage = () => {
    return (
        <Box style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
            <HistoryTable maxHeight="100%" />
        </Box>
    );
};

export default HistoryConversationsPage;
